import classNames from 'classnames'
import { forwardRef, type PropsWithChildren, type ReactElement } from 'react'

import './styles.scss'

const TooltipMenu = forwardRef<HTMLMenuElement, PropsWithChildren<{ isOpen?: boolean }>>(
  ({ children, isOpen }, ref): ReactElement => {
    return (
      <menu className={classNames('tooltip-menu-component', { 'tooltip-menu-component--open': isOpen })} ref={ref}>
        {children}
      </menu>
    )
  }
)

TooltipMenu.displayName = 'TooltipMenu'

export default TooltipMenu
